export default __webpack_public_path__ + "static/extravaganza-969f5f3053465db641ccd68eae6f3519.png";